import React, {Component} from "react";
import {
  ReactiveBase,
  DataSearch,
  MultiList,
  MultiDataList,
  SelectedFilters,
  ResultCard
} from "@appbaseio/reactivesearch";
import './Library.css';
import ReactGA from 'react-ga';
ReactGA.initialize('UA-125267507-1');
ReactGA.pageview(window.location.pathname + window.location.search);

class Library extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isClicked: false,
      message: "Show Filters"
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleSearchClick = this.handleSearchClick.bind(this);
  }

  handleSearchClick() {
    ReactGA.event({
      category: 'engagement',
      action: 'search_clicked',
      label: 'Search Bar'
    });
  }

  handleClick() {
    this.setState({
      isClicked: !this.state.isClicked,
      message: this.state.isClicked ? "Show Filters" : "Show Videos"
    });
  }

  static nFormatter(num, digits) {
    const si = [
      { value: 1, symbol: "" },
      { value: 1E3, symbol: "k" },
      { value: 1E6, symbol: "M" },
      { value: 1E9, symbol: "G" },
      { value: 1E12, symbol: "T" },
      { value: 1E15, symbol: "P" },
      { value: 1E18, symbol: "E" }
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    let i;
    for (i = si.length - 1; i > 0; i--) {
      if (num >= si[i].value) {
        break;
      }
    }
    return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
  }

  render() {
    return (
      <div className="main-container">
        <ReactiveBase
          app="transformations"
          url="https://search.myinnerwork.com/"
          theme={{
            typography: {
              fontFamily:
                '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Droid Sans", "Helvetica Neue", sans-serif',
              fontSize: "16px"
            },
            colors: {
              textColor: "#fff",
              backgroundColor: "#212121",
              primaryTextColor: "#fff",
              primaryColor: "#2196F3",
              titleColor: "#fff",
              alertColor: "#d9534f",
              borderColor: "#666"
            }
          }}
        >
          <div className="sub-container">

            <div
              className={
                this.state.isClicked ? "left-bar-optional" : "left-bar"
              }
            >
              <div className="filter-heading center">
                I want to learn about...
              </div>
              <MultiDataList
                componentId="subject-list"
                dataField="snippet.title"
                className="subject-filter"
                size={100}
                sortBy="asc"
                queryFormat="or"
                selectAllLabel="All Topics"
                showCheckbox={true}
                showSearch={false}
                placeholder="Search for a topic"
                react={{
                  and: [
                    "mainSearch",
                    "results",
                    "teachers-list",
                    "duration-list",
                  ]
                }}
                data={[
                  {
                    label: "Addiction",
                    value: ["Addiction", "addiction", "Addictions", "addictions"]
                  },
                  {
                    label: "Affirmations",
                    value: ["Affirmations", "affirmations", "Affirmation", "affirmation"]
                  },
                  {
                    label: "Anxiety",
                    value: ["Anxiety", "anxiety"]
                  },
                  {
                    label: "Awareness",
                    value: ["Awareness", "awareness"]
                  },
                  {
                    label: "Chakras",
                    value: ["Chakra", "chakra", "Chakras", "chakras"]
                  },
                  {
                    label: "Depression",
                    value: ["Depression", "depression"]
                  },
                  {
                    label: "Energy",
                    value: ["Energy", "energy"]
                  },
                  {
                    label: "Enlightenment",
                    value: ["Enlightenment", "enlightenment"]
                  },
                  {
                    label: "Healing",
                    value: ["Healing", "healing"],
                  },
                  {
                    label: "Gratitude",
                    value: ["Gratitude", "gratitude"]
                  },
                  {
                    label: "Karma",
                    value: ["Karma", "karma"]
                  },
                  {
                    label: "Kriyas",
                    value: ["Kriya", "kriya", "Kriyas", "kriyas"]
                  },
                  {
                    label: "Love",
                    value: ["Love", "love"]
                  },
                  {
                    label: "Mindfulness",
                    value: ["Mindfulness", "mindfulness"]
                  },
                  {
                    label: "Meditation",
                    value: ["Meditation", "meditation", "Mindfulness", "mindfulness"]
                  },
                  {
                    label: "Rebirth",
                    value: ["Rebirth", "rebirth", "Reincarnation", "reincarnation"],
                  },
                  {
                    label: "Relaxation",
                    value: ["Relaxation", "relaxation"]

                  },
                  {
                    label: "Sex",
                    value: ["Sex", "sex"]
                  },
                  {
                    label: "Stress",
                    value: ["Stress", "stress"]
                  },
                  {
                    label: "Yoga",
                    value: ["Yoga", "yoga"]
                  }
                ]}
                showFilter={true}
                filterLabel="Topic"
                URLParams={false}
                innerClass={{
                  label: "list-item",
                  input: "list-input"
                }}
              />
              <div className="filter-heading center">
                I have ...
              </div>
              <MultiDataList
                componentId="duration-list"
                dataField="snippet.duration.keyword"
                className="duration-filter"
                size={5}
                sortBy="asc"
                queryFormat="or"
                selectAllLabel="All Durations"
                showCheckbox={true}
                showSearch={false}
                react={{
                  and: [
                    "mainSearch",
                    "results",
                    "subject-list",
                    "teachers-list",
                  ]
                }}
                data={[
                  {
                    label: "0 - 5 mins",
                    value: "very_short"
                  },
                  {
                    label: "5 - 15 mins",
                    value: "short"
                  },
                  {
                    label: "15 - 30 mins",
                    value: "medium"
                  },
                  {
                    label: "30 - 60 mins",
                    value: "long"
                  },
                  {
                    label: "More than 60 mins",
                    value: "very_long"
                  }
                ]}
                showFilter={true}
                filterLabel="Duration"
                URLParams={false}
                innerClass={{
                  label: "list-item",
                  input: "list-input"
                }}
              />
              <div className="filter-heading center">
                Teachers
              </div>
              <MultiList
                componentId="teachers-list"
                dataField="snippet.teacher.keyword"
                className="teachers-filter"
                size={100}
                sortBy="asc"
                queryFormat="or"
                selectAllLabel="All Teachers"
                showCheckbox={true}
                showCount={true}
                showSearch={true}
                placeholder="Search for a Teacher"
                react={{
                  and: [
                    "mainSearch",
                    "subject-list",
                    "duration-list",
                    "results",
                  ]
                }}
                showFilter={true}
                filterLabel="Teacher"
                URLParams={false}
                innerClass={{
                  label: "list-item",
                  input: "list-input"
                }}
              />
            </div>
            <div
              className={
                this.state.isClicked
                  ? "result-container-optional"
                  : "result-container"
              }
            >
              <div className="search-container" onClick={this.handleSearchClick}>
                <DataSearch
                  componentId="mainSearch"
                  dataField={["snippet.title", "snippet.tags"]}
                  categoryField="title"
                  className="search-bar"
                  queryFormat="and"
                  placeholder="Law of Attraction, Love, Meditation"
                  iconPosition="left"
                  autosuggest={false}
                  innerClass={{
                    list: 'auto-suggest-list'
                  }}
                  filterLabel="search"
                />
              </div>
              <SelectedFilters
                showClearAll={true}
                clearAllLabel="Clear filters"
              />

              <ResultCard
                componentId="results"
                sortBy="desc"
                dataField="snippet.relViews"
                react={{
                  and: [
                    "mainSearch",
                    "teachers-list",
                    "subject-list",
                    "duration-list",
                  ]
                }}
                pagination={false}
                className="Result_card"
                paginationAt="bottom"
                pages={5}
                size={12}
                Loader="Loading..."
                noResults="No results were found..."
                innerClass={{
                  title: "result-title",
                  listItem: "result-item",
                  list: "list-container",
                  sortOptions: "sort-options",
                  resultStats: "result-stats",
                  resultsInfo: "result-list-info",
                  poweredBy: "powered-by"
                }}
                onData={function(res) {
                  let shortTitle = res.snippet.title.substring(0, 45);
                  if (shortTitle.length < res.snippet.title.length) {
                    shortTitle += '...';
                  }
                  return {
                    description: (
                      <div className="main-description">
                        <div className="ih-item square effect6 top_to_bottom">
                            <div className="img">
                              <img
                                src={
                                  (res.snippet.thumbnails.standard && res.snippet.thumbnails.standard.url) || res.snippet.thumbnails.default.url
                                }
                                alt="video thumbnail"
                                className="result-image"
                              />
                            </div>
                        </div>
                        <div className="captions">
                          <div>{shortTitle}</div>
                          <div className="subTitle">{res.snippet.teacher}</div>
                          <div className="subSubTitle">{`${Library.nFormatter(res.snippet.numViews, 1)} Views`}</div>
                        </div>
                      </div>
                    ),
                    url: `/watch/${res.id}`
                  };
                }}
              />
            </div>

            <button
              className="toggle-button"
              onClick={this.handleClick}
            >
              {this.state.message}
            </button>
          </div>
        </ReactiveBase>
      </div>
    );
  }
}

export default Library;



// WEBPACK FOOTER //
// ./src/components/Library.js